import { render, staticRenderFns } from "./GeoDistribution.vue?vue&type=template&id=e6a20320&scoped=true&"
import script from "./GeoDistribution.vue?vue&type=script&lang=js&"
export * from "./GeoDistribution.vue?vue&type=script&lang=js&"
import style0 from "./GeoDistribution.vue?vue&type=style&index=0&id=e6a20320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a20320",
  null
  
)

export default component.exports